import { cn } from '@/lib/utils'

type IManageContainerIconProps = {
  wstype: 'folder' | 'workspace'
  className?: string
}

export function IManageContainerIcon({ wstype, className }: IManageContainerIconProps) {
  const isWorkspace = wstype === 'workspace'

  return (
    <img
      src={isWorkspace ? '/imanage-workspace.svg' : '/imanage-folder.svg'}
      alt={isWorkspace ? 'iManage workspace' : 'iManage folder'}
      className={cn('h-3.5 w-auto shrink-0', className)}
    />
  )
}
